<vdr-datetime-picker
    [formControl]="formControl"
    [min]="min"
    [max]="max"
    [yearRange]="yearRange"
    [readonly]="readonly"
>
</vdr-datetime-picker>
